export const TOTP_MFA = "TOTP";
export const SMS_MFA = "SMS";
export const NO_MFA = "NOMFA";

export const STORAGE_VALUE_MFA = "mfaType";
